<template>
    <div>
        <SubLayout>
            <div v-if="$route.matched.length == 2" slot="center">
                <EventList
                    :value="events"
                    class="mb-4"
                    :listMode="false"
                    :vFairId="this.$route.params.id"
                ></EventList>
            </div>
            <div class="grid-bottom" v-if="$route.matched.length == 2" slot="center">
                <div>
                    <CompanyList
                        :data="featuredCompanies.slice(0, 5)"
                        label="Companies"
                        class="mb-3 w-100"
                        :resolveroute="companyClickRoute"
                        :isLoading="companiesLoading"
                        forceList
                    ></CompanyList>
                </div>
                <div>
                    <PostingModule
                        :data="postingData"
                        class="mb-3 w-100"
                        :resolveroute="resolveRoute"
                        :isLoading="postingLoading()"
                        noToggles
                    ></PostingModule>
                </div>
            </div>
        </SubLayout>
        <router-view></router-view>
    </div>
</template>

<script>
import EventList from './components/EventList';
import CompanyList from '../../../shared/CompanyList';
import PostingModule from '../../../shared/postingmodule/PostingModule';
import SubLayout from '../../../components/layouts/mainlayout/SubLayout';
export default {
    name: 'Events',
    components: {
        SubLayout,
        PostingModule,
        CompanyList,
        EventList,
    },
    computed: {
        events() {
            if (!this.$route.params.id) {
                return [];
            } else {
                return this.$interfaces.vfair.id(this.$route.params.id).events.get({
                    reactive: true,
                }).data;
            }
        },
        postings() {
            return this.$interfaces.posting.get({
                reactive: true,
                vfair_id: this.$route.params.id,
                page_size: 5,
                page: 1,
            });
        },
        postingData() {
            return this.postings.data || [];
        },
        companiesRequest() {
            if (this.$route.params.id) {
                return this.$interfaces.vfair.id(this.$route.params.id).organizations.get({
                    reactive: true,
                });
            } else {
                return { loading: true };
            }
        },
        companies() {
            if (this.companiesRequest.loading) {
                return [];
            } else {
                return this.companiesRequest.data.filter(item => {
                    if (item) {
                        return item.status === 2;
                    }
                    return false;
                });
            }
        },
        companiesLoading() {
            return this.companiesRequest.loading;
        },
        featuredCompanies() {
            return this.companies.map(org => {
                return {
                    id: org.organizationId,
                    logo: org.logo,
                    name: org.title,
                };
            });
        },
    },
    methods: {
        companyClickRoute(id) {
            const url = this.$URLS.vfair
                .concat('/', this.$route.params.id)
                .concat('/companies/', id);
            return url;
        },
        postingLoading() {
            return this.postings.loading;
        },
        resolveRoute(jobAdId) {
            const url = this.$URLS.vfair
                .concat('/', this.$route.params.id)
                .concat('/jobs/', jobAdId);
            return url;
        },
    },
};
</script>
<style scoped>
.grid-bottom {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: var(--grid-gap);
}
@media screen and (max-width: 1116px) {
    .grid-bottom {
        grid-template-columns: 1fr;
    }
}
</style>
